export default {
  title: 'Votre site web est prêt',
  body_one: 'Les réservations sont encore désactivées pour {{count}} restaurant :',
  body_other: 'Les réservations sont encore désactivées pour {{count}} restaurants :',
  reasons: {
    license_required: 'Nécessite un Plan Partenaire',
    notification_email_required:
      "Une adresse e-mail pour les notifications de réservation est nécessaire. Ajoutez-la lors de l'activation des réservations.",
    switched_off: 'Désactivé dans les paramètres de réservation',
    activation_failed: 'Impossible à activer. Veuillez réessayer dans les paramètres de réservation.',
  },
  buttons: {
    open_settings: 'Ouvrir les paramètres de réservation',
    continue: 'Continuer vers le créateur de site web',
  },
};
